import React from 'react';
import { PartyPopper, Calendar, Star } from 'lucide-react';
import { services } from '../data/mockData';

const iconMap = {
  PartyPopper: PartyPopper,
  Calendar: Calendar,
  Star: Star
};

export const Services = () => {
  return (
    <section id="services" className="relative py-24 bg-gradient-to-b from-white via-orange-50 to-yellow-50 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-1/4 h-1/4 bg-gradient-to-br from-orange-200/50 to-yellow-200/50 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-1/3 h-1/3 bg-gradient-to-tl from-emerald-200/40 to-green-200/40 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-orange-600 font-bold text-sm uppercase tracking-wider bg-gradient-to-r from-orange-100 to-yellow-100 px-4 py-2 rounded-full border border-orange-200">
            What We Offer
          </span>
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-burgundy-800 via-red-700 to-orange-700 bg-clip-text text-transparent mt-6 mb-4">
            Our Services
          </h2>
          <p className="text-gray-700 text-lg max-w-2xl mx-auto">
            From intimate gatherings to large-scale events, we bring the vibrant flavors of India wherever you need us
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-orange-100 hover:border-orange-300 overflow-hidden"
              >
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-yellow-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <IconComponent className="text-white" size={32} />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-burgundy-800 to-red-700 bg-clip-text text-transparent mb-4 group-hover:from-orange-600 group-hover:to-yellow-600 transition-all">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>

                {/* Decorative corner accent */}
                <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-gradient-to-br from-orange-300/40 to-yellow-300/40 rounded-full blur-2xl group-hover:from-orange-400/50 group-hover:to-yellow-400/50 transition-colors"></div>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-20 bg-gradient-to-r from-burgundy-900 via-red-900 to-burgundy-800 rounded-3xl p-12 text-center shadow-2xl relative overflow-hidden">
          {/* Decorative elements */}
          <div className="absolute top-0 left-1/4 w-64 h-64 bg-orange-500/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-yellow-500/20 rounded-full blur-3xl"></div>
          
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to Book Desi Fusion?
            </h3>
            <p className="text-orange-100 text-lg mb-8 max-w-2xl mx-auto">
              Let's make your event unforgettable with authentic Indian street food. Contact us today to discuss your requirements and get a custom quote.
            </p>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gradient-to-r from-orange-500 via-orange-600 to-yellow-500 text-white px-10 py-4 rounded-full font-semibold text-lg hover:from-orange-600 hover:via-orange-700 hover:to-yellow-600 transition-all duration-300 hover:scale-105 shadow-xl hover:shadow-orange-500/60"
            >
              Get in Touch
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
